<!-- if the participant is not booked into an execution of the course then we show the course offering (incl. title and image) and it should not be clickable. Only the book now button is clickable in case we have a booking URL. -->
<mat-card
    appearance="outlined"
    fxLayout="column"
    *ngIf="programItem.relevantExecutions.length === 0; else showExecution"
    class="course-offering-card disabled mat-elevation-z0 mb-16 p-0 w-100-p"
    [class.pointer]="!isTeamProgramMemberDialog || (isTeamProgramMemberDialog && programItem.courseOffering.kind === ModuleKind.ProgramExecution)"
>
    <div class="course-offering-image-container w-100-p">
        <div
            class="course-offering-image"
            [ngStyle]="
                programItem.courseOffering.courseTemplate.image && {
                    background: 'url(' + programItem.courseOffering.courseTemplate.image.smallUrl + ') center / cover no-repeat '
                }
            "
            [class.no-image]="!programItem.courseOffering.courseTemplate.image"
        >
            <img
                style="display: none"
                *ngIf="programItem.courseOffering.courseTemplate.image && programItem.courseOffering.courseTemplate.image.unsplash"
                [src]="unsplashViewsBaseUrl + programItem.courseOffering.courseTemplate.image.unsplash.unsplashId"
            />

            <span
                class="module-status"
                *ngIf="programItem.courseProgressStatus"
                [ngClass]="programItem.courseProgressStatus | getStatus: moduleCompletitionStatus:'name'"
                [style.background-color]="programItem.courseProgressStatus | getStatus: moduleCompletitionStatus:'color'"
            >
                {{ programItem.courseProgressStatus | getStatus: moduleCompletitionStatus:'translationLabel' | translate }}
            </span>

            <mat-icon class="bg-icon" svgIcon="bg_illustration" *ngIf="!programItem.courseOffering.courseTemplate.image"> </mat-icon>
        </div>
    </div>
    <mat-card-content fxLayout="column" fxLayoutAlign="start space-between" class="w-100-p p-16" [ngClass]="bgColor">
        <div class="course-offering-title">
            <div fxLayout="row" fxLayoutAlign="start center" class="mb-8">
                <mat-icon class="module-icon mr-8" [svgIcon]="programItem.courseOffering.courseTemplate | getModuleIcon: true"> </mat-icon>
                <span class="module-type" translate>
                    {{ programItem.courseOffering.courseTemplate | getModuleKindLabel }}
                </span>
            </div>
            <div class="mb-16" fxLayout="row" fxLayoutAlign="flex-start center">
                <h2 class="m-0">{{ programItem.courseOffering.name }}</h2>
            </div>
        </div>
        <div *ngIf="programItem.courseOffering.bookingUrl && programItem.courseProgressStatus === null; else notBooked">
            <div fxLayout="column" *ngIf="programItem.relevantExecutions.length">
                <span *ngIf="programItem.relevantExecutions[0].startDate || programItem.relevantExecutions[0].endDate">
                    {{ programItem.relevantExecutions[0].startDate | date: 'mediumDate' }} -
                    {{ programItem.relevantExecutions[0].endDate | date: 'mediumDate' }}
                </span>
            </div>

            <app-flat-button
                class="w-100-p"
                [label]="'GENERAL.LABEL.BOOK_COURSE'"
                (onClick)="bookCourse(programItem.courseOffering.bookingUrl)"
                [disabled]="module?.kind === ModuleKind.ProgramTemplate"
                *ngIf="isTeamProgramMemberDialog ? isCurrentUserTenantAdmin : true"
            ></app-flat-button>
        </div>
        <ng-template #notBooked>
            <span class="not-booked-label">{{ 'GENERAL.LABEL.NOT_BOOKED' | translate }}</span>
        </ng-template>
    </mat-card-content>
</mat-card>

<!-- If the participant is booked into exactly one execution, then the whole tile becomes the execution. So, we should show image, title and state of the execution (and we don't show anything re course offering anymore). But there is also no link for past executions (because there is no past exection. only the current one) -->
<ng-template #showExecution>
    <mat-card
        appearance="outlined"
        fxLayout="column"
        (click)="navigateToExecution(programItem.relevantExecutions[0])"
        class="course-offering-card mat-elevation-z0 mb-16 p-0 w-100-p"
        [class.pointer]="!isTeamProgramMemberDialog || (isTeamProgramMemberDialog && programItem.relevantExecutions[0].kind === ModuleKind.ProgramExecution)"
        [class.disabled]="programItem.relevantExecutions[0].status === ModuleCategory.Archived || programItem.relevantExecutions[0].status === ModuleCategory.Unpublished"
    >
        <div class="course-offering-image-container w-100-p">
            <div
                class="course-offering-image"
                [ngStyle]="
                    programItem.relevantExecutions[0].image && {
                        background: 'url(' + programItem.relevantExecutions[0].image.smallUrl + ') center / cover no-repeat '
                    }
                "
                [class.no-image]="!programItem.relevantExecutions[0].image"
            >
                <img
                    style="display: none"
                    *ngIf="programItem.relevantExecutions[0].image && programItem.relevantExecutions[0].image.unsplash"
                    [src]="unsplashViewsBaseUrl + programItem.relevantExecutions[0].image.unsplash.unsplashId"
                />
                <span
                    class="module-status"
                    *ngIf="programItem.courseProgressStatus"
                    [ngClass]="programItem.courseProgressStatus | getStatus: moduleCompletitionStatus:'name'"
                    [style.background-color]="programItem.courseProgressStatus | getStatus: moduleCompletitionStatus:'color'"
                >
                    {{ programItem.courseProgressStatus | getStatus: moduleCompletitionStatus:'translationLabel' | translate }}
                </span>
                <mat-icon class="bg-icon" svgIcon="bg_illustration" *ngIf="!programItem.relevantExecutions[0].image"> </mat-icon>
            </div>
        </div>

        <mat-card-content>
            <div
                class="course-offering-title p-16 w-100-p"
                [ngClass]="
                    programItem.relevantExecutions[0].status === ModuleCategory.Archived || programItem.relevantExecutions[0].status === ModuleCategory.Unpublished
                        ? 'bg-zinc-50'
                        : bgColor
                "
            >
                <div fxLayout="row" fxLayoutAlign="start center" class="mb-8">
                    <mat-icon
                        class="module-icon mr-8"
                        [svgIcon]="
                            programItem.relevantExecutions[0]
                                | getModuleIcon
                                    : (programItem.relevantExecutions[0].status === ModuleCategory.Archived ||
                                      programItem.relevantExecutions[0].status === ModuleCategory.Unpublished
                                          ? true
                                          : false)
                        "
                    >
                    </mat-icon>
                    <span class="module-type ellipsis-container" translate>
                        {{ programItem.relevantExecutions[0] | getModuleKindLabel }}
                    </span>
                </div>
                <div class="mb-16" fxLayout="row" fxLayoutAlign="flex-start center">
                    <h2 class="m-0">{{ programItem.relevantExecutions[0].name }}</h2>
                </div>

                <!-- For Course, Execution and Program Execution we show progress bar -->
                <div
                    fxLayout="row"
                    fxLayoutAlign="flex-start center"
                    class="progress-bar-container"
                    *ngIf="
                        programItem.courseProgressStatus === ModuleUserProgressStatus.InProgress &&
                        (module?.kind === ModuleKind.ProgramExecution ||
                            (programItem.relevantExecutions[0].sectionRule !== SectionRule.Default && (module?.kind === ModuleKind.Execution || module.kind === ModuleKind.Course)))
                    "
                >
                    <mat-progress-bar
                        attr.aria-label="{{ 'GENERAL.LABEL.PROGRESS_BAR' | translate }}"
                        class="mr-8"
                        mode="determinate"
                        [value]="(programItem.progresses[0].progress.completed / programItem.progresses[0].progress.total) * 100"
                    >
                    </mat-progress-bar>
                    <div fxLayout="row" fxLayoutAlign="flex-start center">
                        <span>{{ programItem.progresses[0].progress.completed }}/</span>
                        <span>
                            {{ programItem.progresses[0].progress.total }}
                        </span>
                    </div>
                </div>

                <!-- In case the participant is booked into multiple exections then we show everything of the last execution and there is the past execution link -->
                <div fxLayout="column" *ngIf="programItem.courseProgressStatus !== ModuleUserProgressStatus.InProgress && programItem.relevantExecutions.length > 1">
                    <span *ngIf="programItem.relevantExecutions[0].startDate || programItem.relevantExecutions[0].endDate">
                        {{ programItem.relevantExecutions[0].startDate | date: 'mediumDate' }} -
                        {{ programItem.relevantExecutions[0].endDate | date: 'mediumDate' }}
                    </span>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
